import React from 'react'

export default function MasterIcon({ className, size = 48 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="32" cy="32" r="30" fill="url(#master-bg)" opacity="0.2" />
      <defs>
        <linearGradient id="master-bg" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#667eea" />
          <stop offset="100%" stopColor="#764ba2" />
        </linearGradient>
        <linearGradient id="master-main" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#fa709a" />
          <stop offset="100%" stopColor="#fee140" />
        </linearGradient>
        <linearGradient id="master-accent" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#ffd89b" />
          <stop offset="100%" stopColor="#19547b" />
        </linearGradient>
      </defs>
      
      {/* Корона основание */}
      <path
        d="M20 36 L20 40 L44 40 L44 36"
        fill="url(#master-main)"
        opacity="0.9"
      />
      
      {/* Зубцы короны */}
      <path
        d="M20 36 L24 26 L28 32 L32 20 L36 32 L40 26 L44 36"
        fill="url(#master-main)"
        stroke="url(#master-main)"
        strokeWidth="1.5"
        strokeLinejoin="round"
        opacity="0.85"
      />
      
      {/* Драгоценные камни */}
      <circle cx="24" cy="26" r="2.5" fill="#fee140" opacity="0.9" />
      <circle cx="32" cy="20" r="3" fill="#fa709a" opacity="0.9" />
      <circle cx="40" cy="26" r="2.5" fill="#fee140" opacity="0.9" />
      
      {/* Средние камни */}
      <circle cx="28" cy="32" r="2" fill="#667eea" opacity="0.8" />
      <circle cx="36" cy="32" r="2" fill="#764ba2" opacity="0.8" />
      
      {/* Орнамент на основании */}
      <rect x="22" y="38" width="3" height="2" fill="#fee140" opacity="0.7" />
      <rect x="30.5" y="38" width="3" height="2" fill="#fee140" opacity="0.7" />
      <rect x="39" y="38" width="3" height="2" fill="#fee140" opacity="0.7" />
      
      {/* Блеск */}
      <path
        d="M32 16 L32.5 17.5 L34 18 L32.5 18.5 L32 20 L31.5 18.5 L30 18 L31.5 17.5 Z"
        fill="#fee140"
        opacity="0.9"
      />
      <path
        d="M42 24 L42.3 24.7 L43 25 L42.3 25.3 L42 26 L41.7 25.3 L41 25 L41.7 24.7 Z"
        fill="#fa709a"
        opacity="0.8"
      />
      <path
        d="M22 24 L22.3 24.7 L23 25 L22.3 25.3 L22 26 L21.7 25.3 L21 25 L21.7 24.7 Z"
        fill="#fa709a"
        opacity="0.8"
      />
      
      {/* Царская основа */}
      <ellipse cx="32" cy="40" rx="12" ry="2" fill="url(#master-accent)" opacity="0.4" />
    </svg>
  )
}
